import { styled } from "styled-components";

export const EventCellDivider = styled.div`
  height: 50px;
  width: 1px;
  background: #c8c8c8;
`;
